import ClientRequestConversation from "./ClientRequestConversation";
import React, { useCallback, useEffect, useState } from "react";
import { graphqlRequest } from "../utils/graphqlRequest";

export default function ClientBookingRequests() {
  const [rows, setRows] = useState([]),
    [error, setError] = useState(""),
    [loading, setLoading] = useState(true);
  const [openId, setOpenId] = useState(null);
  const load = useCallback(async () => {
    try {
      const d = await graphqlRequest(`query{clientBookingRequests}`);
      setRows(d.clientBookingRequests || []);
      setError("");
    } catch (e) {
      setError(e.message || "Could not load booking requests");
    } finally {
      setLoading(false);
    }
  }, []);
  useEffect(() => {
    load();
    const timer = setInterval(load, 30000);
    return () => clearInterval(timer);
  }, [load]);
  return (
    <section
      style={{
        background: "white",
        border: "1px solid #e2e8f0",
        borderRadius: 12,
        padding: 20,
        marginBottom: 20,
      }}
    >
      <div
        style={{ display: "flex", justifyContent: "space-between", gap: 12 }}
      >
        <div>
          <h2>Client booking requests</h2>
          <p>
            Existing clients requesting quotations or services. Each request is
            also in Sales Pipeline.
          </p>
        </div>
        <button onClick={load}>Refresh</button>
      </div>
      {error && (
        <p role="alert" style={{ color: "#b91c1c" }}>
          {error}
        </p>
      )}
      {loading ? (
        <p>Loading…</p>
      ) : !rows.length ? (
        <p>No client booking requests yet.</p>
      ) : (
        <div style={{ overflowX: "auto" }}>
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr>
                {[
                  "Client",
                  "Request",
                  "Site / date",
                  "Pipeline",
                  "Status",
                  "Reference",
                ].map((h) => (
                  <th key={h} style={{ textAlign: "left", padding: 10 }}>
                    {h}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {rows.map((r) => (
                <tr key={r.id} style={{ borderTop: "1px solid #e2e8f0" }}>
                  <td style={{ padding: 10 }}>
                    <b>{r.clientName}</b>
                    <br />
                    {r.email}
                  </td>
                  <td style={{ padding: 10 }}>
                    {r.kind === "booking"
                      ? "Service booking"
                      : "Quotation request"}
                    <br />
                    {r.services.join(", ")}
                    <details>
                      <summary>Details</summary>
                      {r.message || "No additional details"}
                    </details>
                  </td>
                  <td style={{ padding: 10 }}>
                    {r.address}
                    <br />
                    {r.preferredDate}
                  </td>
                  <td style={{ padding: 10 }}>{r.stage}</td>
                  <td style={{ padding: 10 }}>
                    {(r.requestStatus || r.status).replaceAll("_", " ")}
                    <button
                      onClick={() => setOpenId(openId === r.id ? null : r.id)}
                    >
                      Review & reply
                    </button>
                    {openId === r.id && (
                      <ClientRequestConversation
                        bookingId={r.id}
                        onUpdated={load}
                      />
                    )}
                    {r.notificationPending && (
                      <small style={{ display: "block" }}>
                        Notification delivery pending
                      </small>
                    )}
                  </td>
                  <td style={{ padding: 10, fontSize: 12 }}>{r.id}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </section>
  );
}
